// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// link function for translatable text directives
const parseTranslatableText = function(scope: any) {
   const pattern = /^(.*)\%\{linkStart\}(.*)\%\{linkEnd\}(.*)$/m
   const matches = scope.text.match(pattern)
   if (matches && (matches.length === 4)) {
      scope.start = matches[1]
      scope.middle = matches[2]
      return scope.end = matches[3]
   }
}

// helper function for handling touch devices
const normalizePoints = function(event: any) {
   if ((event.touches == null)) { return event }
   event = event.touches[0]
   return event = {
      pageX: event.pageX,
      pageY: event.pageY
   }
}

const FulltextBanner = () => ({
   replace: true,
   templateUrl: '/assets/fulltextBanner.html'
})

// @ts-expect-error TS(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
const HamburgerMenu = ($timeout, configs) => ({
   templateUrl: '/assets/hamburger.html',

   link(s: any) {
      const htmlBody = angular.element('body')
      s.linksMenuFocusFirst = function(e: any) {
         e.preventDefault()
         return $timeout(() => $('div.linksMenu').find(':focusable:first').focus())
      }
      s.toggleMenu = function(e: any) {
         e.stopPropagation()
    

         if (!s.subMenu.links.open) {
            s.subMenu.links.openMenu()
            htmlBody.on('click', function(e: any) {
               // remove 'click' event from body when closing the menu
               htmlBody.off('click')
               // apply timeout to account for form submissions, 
               // but for EndNote Fusion login don't close menu at all because of waiting on api response and also redirect makes closing unnecessary
               const flowAuthUrl = configs.data.flow?.authUrl || ''
               if(!(e?.target?.form?.action === flowAuthUrl)) {
                  return $timeout( function() {
                     s.subMenu.links.closeMenu()
                     return s.$apply()
                  }
                  , 0)
               }
               return // required to prevent error: 'Referencing DOM nodes in Angular expressions is disallowed'
            })
            return // required to prevent error: 'Referencing DOM nodes in Angular expressions is disallowed'
         } else {
            return s.subMenu.links.closeMenu()
         }
      }

      return s.$on('$destroy', () => htmlBody.off('click'))
   }
})

const Menu = ($timeout: any) => ({
   controller: 'MenuCtrl',

   scope: {
      type: '@menuType',
      name: '@menuName',
      pinned: '<menuPinned',
      openSize: '<menuOpen',
      closeSize: '<menuClose',
      floatSize: '<menuFloat',
      pinnable: '<menuPinnable',
      closeOnAppstateChange: '<menuCloseOnAppstateChange'
   },

   link(scope: any, el: any, attr: any) {
      scope.$watch('open',
         (open: any) => { 
            // focus the first focusable element when opening the menu - check on 'userState' means we know a user clicked it, not a responsive layout change event
            if (open && scope.userState) {
               return $timeout( () => $('*[menu-name="' + scope.name + '"] .floatingPanelContent').find(':focusable:first').focus()
                  , 50)
            }
         })

      return scope.$watch('floating', 
         (shouldFloat: any) => { 
            if (shouldFloat) {
               return attr.$addClass('floatingPanel')
            } else {
               return attr.$removeClass('floatingPanel')
            }
         })
   }
})


const MenuPinToggle = (menuManagerService: any) => ({
   scope: {
      name: '@menuToggleName'
   },

   link(scope: any, el: any, attr: any) {
      return el.on('click', function() {
         if (menuManagerService.menu[scope.name].pinned) {
            menuManagerService.menu[scope.name].unpin()
         } else {
            menuManagerService.menu[scope.name].pin()
         }
         return scope.$apply()
      })
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
const MenuToggle = ($timeout, $window, menuManagerService) => ({
   // '>' is one-way binding - it's parsed as a boolean
   scope: {
      forceClose: '<menuToggleForceClose',
      name: '@menuToggleName',
      pin: '<menuTogglePin', //if pin==true, then the menu is also pinned on click
      scrollTop: '<menuToggleScrollTop',
      focusAfterOpen: '@menuToggleFocusAfterOpen', //selector to focus into after the menu opens
      focusAfterClose: '@menuToggleFocusAfterClose' //selector to focus after the menu closes
   },

   link(scope: any, el: any, attr: any) {
      const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      // Move focus to the element matched by selector, or to its first focusable
      // descendant when the match is a container (used to land on the panel content
      // after opening, or back on the toggle button after closing). Runs after the
      // digest so the target is no longer hidden and can receive focus.
      const focusInto = (selector: string) => {
         if (!selector) { return }
         $timeout(() => {
            const match = angular.element(selector).filter(':visible').first()
            if (!match.length) { return }
            if (match.is(FOCUSABLE)) { return match.focus() }
            // If caller intentionally targets a non-tabbable container (tabindex="-1"),
            // focus that container instead of jumping to the first descendant.
            if (match.is('[tabindex]')) { return match.focus() }
            const target = match.find(FOCUSABLE).filter(':visible').first()
            if (target.length) { return target.focus() }
            return match.attr('tabindex', -1).focus()
         })
      }
      return el.on('click', function() {
         if (scope.forceClose) {
            menuManagerService.menu[scope.name].closeMenu(true)
            if (scope.pin) {
               menuManagerService.menu[scope.name].unpin()
            }
            focusInto(scope.focusAfterClose)
         } else if (menuManagerService.menu[scope.name].open) {
            menuManagerService.menu[scope.name].closeMenu(true)
            if (scope.pin) {
               menuManagerService.menu[scope.name].unpin()
            }
            focusInto(scope.focusAfterClose)
         } else {
            menuManagerService.menu[scope.name].openMenu(true)
            if (scope.pin) {
               menuManagerService.menu[scope.name].pin()
            }
            focusInto(scope.focusAfterOpen)
         }

         scope.$apply()
         if (scope.scrollTop) {
            return $timeout(() => $window.scrollTo(0,0))
         }
      })
   }
})

const Permalink = function($document: any, $window: any, translationService: any, $timeout: any, config: any, shortener: any) {

   const {
      enableShortenPermalink
   } = config.data.results

   return {
      templateUrl: '/assets/permalink.html',
      link: {
         pre(s: any, el: any, attrs: any) {
            return s.recordAction = attrs.permalink === 'recordAction'
         },
         post(s: any, el: any) {
            const {
               location
            } = $window
            const urlPort = location.port ? ":" + location.port : ""
            const urlBase = location.protocol + "//" + location.hostname + urlPort
            s.bookmarkUrl = urlBase + "/#!/search?bookMark=" + s.document.bookmark

            // Reverse logic to avoid shorten when disabled
            s.shortened = !enableShortenPermalink
            const clickHandler = function(evt: any) {
               evt.stopPropagation()
               el.find("input[type=text]").focus()
               if (enableShortenPermalink) {
                  return shortener.getShorten(s.document.bookmark, s.bookmarkUrl).then(function(url: any){
                     s.bookmarkUrl = url
                     return s.shortened = true
                  })
               }
            }

            el.on('click', clickHandler)

            // -- permalink dialog functionality -- #
            const successMsg = translationService.translations.PERMANENT_LINK_COPIED_TO_CLIPBOARD
            const failureMsg = translationService.translations.PERMANENT_LINK_COPY_ERROR
            s.copyAttempted = false

            s.back = function() {
               el.find('button.copyBtn').focus()
               return s.copyAttempted = false
            }

            s.closePermalink = function($event: any) {
               $event.preventDefault()
               $event.stopPropagation()
               return $timeout(() => el.find('button.dropdown-toggle').trigger('click').focus())
            }

            s.copy = function($event: any) {
               $event.stopPropagation()
               el.find("input[type=text]").select()
               s.copyAttempted = true
               try {
                  const successfulCopy = $document[0].execCommand("copy")
                  if (successfulCopy) {
                     s.isSuccess = true
                     return s.msg = successMsg
                  } else {
                     s.isSuccess = false
                     return s.msg = failureMsg
                  }
               } catch (e) {
                  s.isSuccess = false
                  return s.msg = failureMsg
               }
            }
            // -- permalink dialog functionality -- #

            // clean things up
            return s.$on('$destroy', () => el.off('click', clickHandler))
         }
      }
   }
}

const ConfirmClick = ($window: any) => ({
   priority: 1,

   scope: {
      confirmAction: '&'
   },

   link: {
      pre(scope: any, element: any, attr: any) {
         const msg = attr.confirmClick || "Are you sure?"

         const confirm = function(e: any) {
            if ($window.confirm(msg)) {
               return scope.$apply(scope.confirmAction())
            } else {
               e.stopImmediatePropagation()
               return e.preventDefault()
            }
         }

         element.on("click", confirm)

         // clean up on destroy
         return scope.$on('$destroy', () => element.off('click', confirm))
      }
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
const VpnBanner = ($timeout, $compile) => ({
   replace: true,
   templateUrl: '/assets/vpnBanner.html',

   compile() {
      return {
         post(scope: any, elem: any){
            return $timeout(function() {
               const caller = elem.find('.vpnBannerLink')
               if (caller.length !== 0) {
                  caller.removeClass('vpnBannerLink')
                  caller.attr('ellipsis-height', '32')
                  caller.attr('ellipsis', '')
                  return $compile(caller)(scope)
               }
            }
            , 0)
         }
      }
   }
})

const TopLinks = () => ({
   replace: true,
   templateUrl: '/assets/topLinks.html',
   controller: 'TopLinksCtrl'
})

const TranslatableTextWithLink = () => ({
   replace: true,
   template: '<span>{{start}}<a ng-attr-id="{{linkId}}" ng-click="click()" class="customPrimaryLink" tabindex="0" role="link">{{middle}}</a>{{end}}</span>',

   scope: {
      linkId: '@?',
      text: '@',
      click: '&'
   },

   link: parseTranslatableText
})

const TranslatableTextWithDropdown = (menuManager: any) => ({
   replace: true,
   transclude: true,
   templateUrl: '/assets/translatableTextWithDropdown.html',

   scope: {
      text: '@',
      readableLabel: '@',
      labelClass: '@'
   },

   link(scope: any){
      const name = 'translatableTextWithDropdown' + scope.$id
      const config = { 
         name,
         type: 'dropdown',
         close: ['any']
      }
  
      menuManager.registerMenu(config)
      scope.onToggle = function(status: any) {
         if (status) {
            return menuManager.subMenu[name].openMenu()
         } else {
            return menuManager.subMenu[name].closeMenu()
         }
      }

      return parseTranslatableText(scope)
   }
})

// handle IE issue w/anchors that have empty or '#' href values
const DynamicLink = () => ({
   replace: true,

   scope: {
      isInternal: '@',
      linkClass: '@',
      link: '@',
      text: '@',
      noEllipsis: '@',
      click: '&',
      openLink: '&',
      ariaLabelCustom: '@',
      linkLabel: '@'
   },

   templateUrl: '/assets/dynamicLink.html'
})

// use dotdotdot jQuery plugin to add ellipsis to shorten length of various elements
const Ellipsis = ($timeout: any) => ({
   restrict: 'A',
   link(scope: any, element: any) {
      //add ellipsis effect only after 3 lines
      element.addClass('ellipsis-3');
   }
})

// use this directive to set add textWidth to textInfo object... 
// textInfo object should have textToMeasure string already set and textWidth attribute will be created or replaced 
const KnowTextWidth = ($timeout: any) => ({
   restrict: 'A',

   scope: {
      textInfo: '='
   },

   link(scope: any, element: any) {
      const getCssStyle = (element: any, prop: any) => angular.element(element).css(prop)

      const getCanvasFontSize = function(el = document.body) {
         const fontWeight = getCssStyle(el, 'font-weight') || 'normal'
         const fontSize = getCssStyle(el, 'font-size') || '16px'
         const fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman'

         return `${fontWeight} ${fontSize} ${fontFamily}`
      }

      const getTextWidth = function(text: any, font: any, scope: any) { 
         // re-use canvas object for better performance
         const canvas = scope.canvas || (scope.canvas = document.createElement("canvas"))
         const context = canvas.getContext("2d")
         context.font = font
         const metrics = context.measureText(text)
         return metrics.width
      }

      return scope.textInfo = { 
         textWidth : getTextWidth(scope.textInfo.textToMeasure, getCanvasFontSize(element), scope),
         textToMeasure : scope.textInfo.textToMeasure
      }
   }
})
        
const SavedItemsDialog = () => ({
   replace: true,
   templateUrl: '/assets/savedItemsDialog.html'
})


const DetailPage = () => ({
   replace: true,
   controller: 'DocumentDetailCtrl',
   templateUrl: '/assets/detailPage.html',
   link:{
      pre(scope: any) {
         scope.isMobile = window.innerWidth < 700 
      }
   }
})

const HomeView = () => ({
   replace: true,
   templateUrl: '/assets/home.html',
   controller: 'HomeCtrl',
})

const SearchView = () => ({
   replace: true,
   controller: 'SearchCtrl',
   templateUrl: '/assets/search.html'
})

const SearchResultsTabs = () => ({
   templateUrl: '/assets/searchResultsTabs.html'
})

const Links = (config: any) => ({
   replace: true,
   templateUrl: '/assets/links.html',

   link(scope: any) {
      return scope.enableWidgetsLink = config.data.widgets.enableWidgetsLink
   }
})

const CustomLinksHeader = () => ({
   replace: true,
   templateUrl: '/assets/customLinksHeader.html',
   controller: 'LinksCtrl'
})

const CustomLinksMenu = () => ({
   replace: true,
   templateUrl: '/assets/customLinksMenu.html',
   controller: 'LinksCtrl'
})

const NavTabs = () => ({
   replace: true,
   templateUrl: '/assets/navTabs.html'
})

const LanguageSwitcher = () => ({
   replace: true,
   controller: 'LocalizationCtrl',
   templateUrl: '/assets/languageSwitcher.html'
})

const MenuBar = () => ({
   replace: true,
   controller: 'MenuBarCtrl',
   templateUrl: '/assets/menuBar.html'
})

const FacetDatepickers = (translationService: any) => ({
   replace: true,
   templateUrl: '/assets/facetDatepickers.html',

   scope: {
      source: '=',
      date: '='
   },

   link(scope: any) {
      return scope.i18n = translationService
   }
})


// @ts-expect-error TS(7006) FIXME: Parameter 'config' implicitly has an 'any' type.
const LinkedContributorList = (config, translationService) => ({
   scope: {
      contributors: '=',
      onSearch: '&?',
      hidePrefix: '=',
      limit: '@',
      label: '@'
   },

   replace: true,
   templateUrl: '/assets/linkedContributorList.html',

   link(scope: any) {
      scope.i18n = translationService
      scope.enableTransliterations = config.data.results.enableTransliterations
      scope.hasSearch = typeof scope.onSearch === 'function'
      scope.limitItems = scope.limit
      scope.showAll = false
      return scope.viewMore = () => {
         scope.showAll = true
         return scope.limitItems = scope.showAll ? scope.contributors.length : scope.limit
      }
   }
})

const LinkedSubjectList = () => ({
   scope: {
      subjects: '=',
      subjectSearch: '&',
      delimiter: '@'
   },

   replace: true,
   templateUrl: '/assets/linkedSubjectList.html'
})

const JournalTitleSearchLink = () => ({
   replace: true,
   templateUrl: '/assets/journalTitleSearchLink.html'
})

const Layout = function() {
   return {controller: 'LayoutCtrl'}
}

const Header = () => ({
   replace: true,
   templateUrl: '/assets/header.html'
})

// Directive for 'back to top' button 
const BackToTop = ($window: any, translationService: any) => ({
   replace: true,
   templateUrl: '/assets/backToTop.html',
   scope: {
     containerId: '@', // the parent container id where the back-to-top button is located. If there is no id, then set one in the html where the btn is located
   },

   link(scope: any) {
      scope.i18n = translationService
      const initResultsScrollListener = () => {
         const container = document.getElementById(scope.containerId)
         scope.isScrolledDown = false
         if (!container) {
            console.error(`Element with ID "${scope.containerId}" not found.`)
            return
         }
   
         // Attach the scroll event listener to the child container
         angular.element(container).on('scroll', () => {
            const scrollTop = container.scrollTop // Use scrollTop for non-window elements
   
            scope.$applyAsync(() => {
               scope.isScrolledDown = scrollTop > 100 
            })
         })
   
         // Clean up on scope destroy
         scope.$on('$destroy', () => {
            angular.element(container).off('scroll')
         })
      }
      scope.scrollToTop = () => {
         scope.isScrolledDown = false
      
         // Get the child container
         const container = document.getElementById(scope.containerId)
         if (!container) {
            console.error(`Scrolling container ${container} not found`)
            return
         }
      
         // Smooth scroll to top
         container.scrollTo({
            top: 0,
            behavior: 'smooth'
         })
         $window.scrollTo(0, 0)
      }

      initResultsScrollListener()

   }
 })

 const ScrollToTopOnClick = () => ({
    restrict: 'A',
    scope: {
       containerId: '@'
    },

    link(scope: any) {
       const containerId = scope.containerId || 'main'
       const resultsContainer = document.getElementById(containerId);
       if (!resultsContainer) {
          console.error("Child container not found");
          return;
       }

       // Smooth scroll to top
       resultsContainer.scrollTo({
          top: 0,
          behavior: "auto",
       });
    },

 })
// @ts-expect-error TS(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
const ScrollToTop = ($window, $timeout) => ({
   restrict: 'A', // restrict to attribute. Used in html as scroll-to-top="click"

   link(scope: any, element: any, attrs: any) {
      const delay = attrs.scrollDelay || 0
      element.on(attrs.scrollToTop, () => $timeout((() => $window.scrollTo(0,0)), delay))

      return scope.$on('$destroy', () => element.off(attrs.scrollToTop))
   }
})
 
const IdleTimer = function($document: any, config: any, flow: any) {

   const {
      savedItemsTimeout
   } = config.data.savedSearchAndItems

   return {
      link(scope: any, element: any) {
         var setUpTimer = function() {
            // wire up setUpTimer to the flow service 'once' hook on initial load
            if (flow.auth.user === undefined) { return flow.once('authChange', setUpTimer) }
            // set up the timer on initial load only if user is NOT a flow authenticated user
            if (!flow.auth.user.authenticated) {
               const idleTime = savedItemsTimeout*60*1000
               const idleMessageTime = idleTime - 300000 // Idle time less 5 minutes

               // Set general idle timer for saved items clear
               scope.idle = false
               $document.on('idle.idleTimer', () => scope.$apply(() => scope.idle = true))
               $document.on('active.idleTimer', () => scope.$apply(() => scope.idle = false))
               $document.idleTimer(idleTime) // user marked 'idle' after savedItemsTimeout minutes

               // Set general idle timer for message 5 minutes before saved items clear
               scope.idleMessage = false
               element.on('idle.idleTimer', function(event: any){
                  event.stopPropagation() // Prevent idle call
                  return scope.$apply(() => scope.idleMessage = true)
               })
               element.on('active.idleTimer', () => scope.$apply(() => scope.idleMessage = false))
               return element.idleTimer(idleMessageTime)
            }
         }

         return setUpTimer()
      }
   }
}

const Citation = () => ({
   replace: true,

   scope: {
      documents: '=',
      list: '=',
      citationSource: '@'
   },

   controller: 'CitationCtrl',
   templateUrl: "/assets/citation.html"
})

const CitationSidebar = () => ({
   replace: true,

   scope: {
      documents: '=',
      view: '='
   },

   controller: 'CitationCtrl',
   templateUrl: "/assets/citationSidebar.html"
})

// @ts-expect-error TS(7006) FIXME: Parameter '$document' implicitly has an 'any' type... Remove this comment to see the full error message
const Draggable = ($document, $window) => ({
   scope: {
      dragClass: '@'
   },

   link(scope: any, element: any) {
      const endTypes = 'touchend touchcancel mouseup mouseleave'
      const moveTypes = 'touchmove mousemove'
      const startTypes = 'touchstart mousedown'
      const {
         dragClass
      } = scope
      const windowEl = angular.element($window)
      const windowHeight = windowEl.height()
      const windowWidth = windowEl.width()

      const moveTypesArray = moveTypes.split(' ')

      return element.on(startTypes, function(event: any) {
         const target = $(event.target)
         if (!target.hasClass(dragClass) && !target.parent().hasClass(dragClass)) { return }
         event.preventDefault()
         let elementStartX = parseInt(element.css('left'))
         let elementStartY = parseInt(element.css('top'))
         const interactionStart = normalizePoints(event)

         if (isNaN(elementStartX)) {
            elementStartX = 0
         }
         if (isNaN(elementStartY)) {
            elementStartY = 0
         }

         let scheduled: any = undefined

         const moveElement = function(event: any) {
            const interactionCurrent = normalizePoints(event)

            element.css({
               left: elementStartX + (interactionCurrent.pageX - interactionStart.pageX) + 'px',
               top: elementStartY + (interactionCurrent.pageY - interactionStart.pageY) + 'px'
            })

            return scheduled = undefined
         }

         const throttled = typeof requestAnimationFrame !== 'undefined' ? function(event: any){
            if (scheduled) {
               cancelAnimationFrame(scheduled)
               scheduled = undefined
            }
            return scheduled = requestAnimationFrame(() => moveElement(event))
         }
            : _.throttle(moveElement, 50)

         $document.on(moveTypes, throttled)

         return $document.on(endTypes, function(event: any) {
            event.preventDefault()
            // don't let draggable element go above viewable area
            if (element.position().top < 0) { element.css('top', 0) }
            // don't let draggable element go below viewable area
            if (windowHeight || windowHeight === 0) {
               if ((element.position().top + element.outerHeight()) > windowHeight) { 
                  element.css('top', windowHeight - element.outerHeight()) 
               }
            }
            // don't let draggable element go left of viewable area
            if (element.position().left < 0) { element.css('left', 0) }
            // don't let draggable element go right of viewable area
            if (windowWidth || windowWidth === 0) {
               if ((element.position().left + element.outerWidth()) >= windowWidth) { 
                  element.css('left', windowWidth - element.outerWidth()) 
               }
            }
            return moveTypesArray.map((type) =>
               $document.off(type, throttled))
         })
      })
   }
})


const NgEnter = ($timeout: any) => ({
   link(scope: any, element: any, attrs: any) {
      element.on('keypress', function(evt: any) {
         if (evt.which === 13) {
            $timeout(() => scope.$eval(attrs.ngEnter))
            return evt.preventDefault()
         }
      })

      return scope.$on('$destroy', () => element.off('keypress'))
   }
})

const KeyedClick = () => ({
   link(scope: any, element: any, attrs: any) {
      element
         .on('keypress', function(evt: any) {
            if ((evt.which === 13) || (evt.which === 32)) {
               scope.$apply(scope.$eval(attrs.keyedClick))
               return evt.preventDefault()
            }
         }).on('click', function(evt: any) {
            scope.$apply(scope.$eval(attrs.keyedClick))
            return evt.preventDefault()
         })

      return scope.$on('$destroy', () => element
         .off('keypress')
         .off('click'))
   }
})

const ToggleImage = ($timeout: any) => ({
   scope: {
      doc: '=toggleImage'
   },

   link(scope: any, element: any) {
      /*
      This directive looks silly but it fixes an issue
      where a 1x1 thumbnail is returned.
      When this occurs, we set the thumbnails to false
      so they properly toggle the cover image.
    */

      if (!scope.doc.display_thumbnail) { scope.doc.display_thumbnail = false }

      const getNatural = (el: any) => ({
         width: el.naturalWidth,
         height: el.naturalHeight
      })

      element.on('load', function() {
         const natural = getNatural(element[0])
         return $timeout(() => scope.doc.display_thumbnail = (natural.width !== 1) && (natural.height !== 1))
      })

      return scope.$on('$destroy', () => element.off('load'))
   }
})

const HideUntilLoaded = ($timeout: any) => ({
   link(scope: any, element: any, attr: any) {
      /*
      This directive checks the src attribute, if it changes it hides the element
      until it is loaded, and then shows it again
    */
      // should fade by default
      const imgObserver = attr.$observe('ngSrc', () => {
         return element.removeClass('fadein-animated').addClass('loading-image')
      })
    
      attr.$addClass('loading-image')

      const getNatural = (el: any) => ({
         width: el.naturalWidth,
         height: el.naturalHeight
      })

      element.on('load', () => $(element).addClass('fadein-animated').removeClass('loading-image'))

      return scope.$on('$destroy', function() {
         element.off('load')
         attr.$set('ngSrc', '')
         return imgObserver()
      })
   }
})

// this directive provides a workaround for invasive proxy servers that inject JS around POST actions - SUM-91028
const SummonFormAction = () => ({
   link(scope: any, elm: any, attrs: any) {
      const submitBtn = elm.find('input[type=submit],button[type=submit]')
      submitBtn.on('click', function() {
         elm.attr('action', scope.$eval(attrs['summonFormAction']))
         const beforeSendPromise = scope.$eval(attrs['beforeSend'])
         if(!beforeSendPromise) {
            elm.submit()
         } else {
            beforeSendPromise.then((res: any) => {
               for (let key in res) {
                  elm.append(`<input type="hidden" name="${key}" value="${res[key]}">`)
               }
               elm.submit()
            })
         }
      })

      return scope.$on('$destroy', () => submitBtn.off('click'))
   }
})

// supports values like '5y' (5 years) 12m (12 months) 5d (5 days) - make sure to add i18n if you add a new preset!
const DatePresetLinks = (translationService: any) => ({
   replace: true,
   templateUrl: '/assets/datePresetLinks.html',

   scope: {
      date: "=",
      presets: "=",
      datePresetLinks: "&",
      labels: "=?"
   },

   // is string
   link(scope: any, el: any, attrs: any) {
      scope.i18n = translationService
      if (!scope.labels) { scope.labels = {} }
      return scope.noTitle = attrs['noTitle'] === "true"
   }
})


// @ts-expect-error TS(7006) FIXME: Parameter 'translationService' implicitly has an '... Remove this comment to see the full error message
const FacetDatePresetLinks = (translationService, viewStateService) => ({
   replace: true,
   templateUrl: '/assets/facetDatePresetLinks.html',

   scope: {
      presets: "=",
      retrievePresetDates: "&",
      labels: "=?",
      selection: "<",
      facetDatepicker: "<",
      toggleFacetDatepicker: "&",
      source: '='
   },

   link(scope: any) {
      scope.i18n = translationService
      if (!scope.labels) { scope.labels = {} }
      return scope.viewState = viewStateService
   }
})
    
const LibraryNotes = () => ({
   replace: true,
   templateUrl: '/assets/libraryNotes.html',
   scope: {
      notes: '='
   },
})


const PreviewEnv = () => ({
   restrict: 'C',
   templateUrl: '/assets/previewEnv.html'
})

const Recaptcha = (recaptchaService: any, $timeout: any) => ({
  restrict: 'A',

  link(scope: any, element: any, attrs: any) {
    const recaptchaId = attrs.appRecaptchaEnterprise


    const init = () => {
      console.log("Calling reCAPTCHA enterprise for:", recaptchaId)

      recaptchaService
        .execute("ui_unlock", recaptchaId)
        .then(() => {
          console.log("Directive validated:", recaptchaId)

          // THIS unlocks the button in CitationController
          scope.$root.$broadcast("recaptchaValidated", true)

          if (!scope.$$phase) {
            scope.$applyAsync()
          }
        })
        .catch((e: any) => {
          console.error("Enterprise recaptcha failed:", e)
          scope.$root.$broadcast("recaptchaValidated", false)
        })
    }

    $timeout(init, 200)
  }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'translationService' implicitly has an '... Remove this comment to see the full error message
const ModalHeader = (translationService, dialogService) => ({
   replace: true,
   templateUrl: '/assets/modalHeader.html',

   scope: {
      view: "@",     //string - quick-look/advanced-search
      headerTitle: "@",    //string - Quick Look / Advanced Search
      ctrl: "=",
      iconName: "@",
      uxfIconName: "@"
   },

   link(scope: any) {
      scope.i18n = translationService
      scope.viewState = dialogService.viewState
      return scope.closeDialog = ($event:any) => dialogService.closeModalDialog($event)
   }
})

const Pagination = () => ({
   replace: true, 
   scope: {
      itemsCount: '=',
      view: '@', //string - search/citation-trail
      selectedTab: '=?',
      itemsPerPage: '=?'
   },
   templateUrl: '/assets/resultsFeed/pagination.html',
   controller: 'PaginationCtrl',

})

const QuickLookContent = () => ({
   replace: true,
   templateUrl: '/assets/quickLook/quickLookContent.html',
   link:{
      pre(scope: any) {
         scope.isMobile = window.innerWidth < 700 
      }
   }
})

const QuickLookDetails = () => ({
   replace: true,
   templateUrl: '/assets/quickLook/quickLookDetails.html'
})
  
const QuickLookNavigation = () => ({   replace: true,
   templateUrl: '/assets/quickLook/quickLookNavigation.html'
})

const RecordActionsGroup = () => ({
   replace: true,
   templateUrl: '/assets/recordActionsGroup.html'
})

const TitleToggle = (translationService: any) => ({
   templateUrl: '/assets/titleToggle.html',

   scope: {
      titleLabel: '@',
      title: '@',
      detailsExpanded: '='
   },

   link(s: any) {
      s.i18n = translationService
      return s.toggleCollapsed = (action: any) => s.detailsExpanded[action] = !s.detailsExpanded[action]
   }
})

const SecondaryResourceTypesWarning = () => ({
   replace: true,
   templateUrl: '/assets/secondaryResourceTypesWarning.html'
})

const Visible = () => ({
   link(scope: any, element: any, attrs: any) {
      return scope.$watch(attrs.visible, function(value: any) {
         if (value) {
            return attrs.$removeClass('invisible')
         } else {
            return attrs.$addClass('invisible')
         }
      })
   }
})

// Enables up/down/home/end arrow key navigation between focusable items inside a
// menu container for menus that are not built on uib-dropdown (which provides its
// own keyboard-nav). Used by the hamburger links menu and the language switcher
// dialog. Up/Down move to the previous/next item (wrapping), Home jumps to the
// first item and End to the last. When given a value, it is used as a selector for
// "row" containers: navigation then moves between rows (focusing each row's first
// focusable) so Tab can still move between items within a row.
const ArrowNavMenu = (localizationService: any) => ({
   link(scope: any, element: any, attrs: any) {
      const itemSelector = 'a[href], a[tabindex], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      const rowSelector = attrs.arrowNavMenu
      // Horizontal lists navigate with Left/Right; vertical lists with Up/Down.
      const horizontal = attrs.arrowNavHorizontal !== undefined
      // In RTL the visual order of a horizontal list is reversed, so Right should
      // move to the previous item and Left to the next to match on-screen order.
      const { isRTL } = localizationService.localization
      // 38 = Up, 40 = Down, 37 = Left, 39 = Right, 36 = Home, 35 = End
      const prevKey = horizontal ? (isRTL ? 39 : 37) : 38
      const nextKey = horizontal ? (isRTL ? 37 : 39) : 40
      const nextIndexFor = (which: number, currentIndex: number, length: number) => {
         switch (which) {
            case 36: return 0
            case 35: return length - 1
            case nextKey: return currentIndex < length - 1 ? currentIndex + 1 : 0
            default: return currentIndex > 0 ? currentIndex - 1 : length - 1
         }
      }
      element.on('keydown', function(evt: any) {
         if ([prevKey, nextKey, 36, 35].indexOf(evt.which) === -1) { return }
         let items
         if (rowSelector) {
            items = element.find(rowSelector).filter(':visible')
            if (!items.length) { return }
            const currentRow = $(evt.target).closest(rowSelector)
            const currentIndex = items.index(currentRow)
            const nextIndex = nextIndexFor(evt.which, currentIndex, items.length)
            const target = $(items[nextIndex]).find(itemSelector).filter(':visible')[0]
            if (target) { target.focus() }
         } else {
            items = element.find(itemSelector).filter(':visible')
            if (!items.length) { return }
            const currentIndex = items.index(evt.target)
            const nextIndex = nextIndexFor(evt.which, currentIndex, items.length)
            items[nextIndex].focus()
         }
         evt.preventDefault()
         return evt.stopPropagation()
      })
      return scope.$on('$destroy', () => element.off('keydown'))
   }
})

// Complements ui-bootstrap's built-in keyboard navigation for uib-dropdown menus
// that opt in via the `keyboard-nav` attribute. ui-bootstrap wires Up/Down arrows
// (see UibDropdownService.keybindFilter / focusDropdownEntry in the vendored
// ui-bootstrap), but not Home/End. This directive adds them so Home focuses the
// first menu entry and End the last, matching the ARIA menu/listbox pattern.
const KeyboardNav = () => ({
   restrict: 'A',
   link(scope: any, element: any) {
      element.on('keydown', function(evt: any) {
         // 36 = Home, 35 = End
         if ((evt.which !== 36) && (evt.which !== 35)) { return }
         // Mirror ui-bootstrap's focusDropdownEntry item lookup. When the menu is
         // closed the entries are not visible, so this is a no-op.
         const items = element.find('ul').eq(0).find('a').filter(':visible')
         if (!items.length) { return }
         const target = evt.which === 36 ? items[0] : items[items.length - 1]
         target.focus()
         evt.preventDefault()
         return evt.stopPropagation()
      })
      return scope.$on('$destroy', () => element.off('keydown'))
   }
})

// When focus is anywhere in this container but NOT inside the target selector,
// an up/down arrow jumps to the first focusable item inside the target. Lets a
// user enter a list (e.g. the language dialog) with arrows without tabbing past
// other controls first. Tab navigation is left untouched.
const ArrowFocusTarget = ($timeout: any) => ({
   link(scope: any, element: any, attrs: any) {
      const itemSelector = 'a[href], a[tabindex], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      const list = element.find(attrs.arrowFocusTarget)
      // Focus the list container (not an item) on open so up/down enter the list
      // immediately without activating any link. arrow-nav-menu then moves to items.
      if (list.length) {
         list.attr('tabindex', '-1')
         $timeout(() => list[0].focus())
      }
      element.on('keydown', function(evt: any) {
         if ((evt.which !== 38) && (evt.which !== 40)) { return }
         const target = element.find(attrs.arrowFocusTarget)
         if (!target.length || target[0].contains(evt.target)) { return }
         const first = target.find(itemSelector).filter(':visible')[0]
         if (!first) { return }
         first.focus()
         evt.preventDefault()
         return evt.stopPropagation()
      })
      return scope.$on('$destroy', () => element.off('keydown'))
   }
})
        

angular.module('summonApp.directives')
   .directive('fulltextBanner', FulltextBanner)
   .directive('hamburgerMenu', ['$timeout', 'configService', HamburgerMenu])
   .directive('menuToggle', ['$timeout', '$window', 'menuManagerService', MenuToggle])
   .directive('menuPinToggle', ['menuManagerService', MenuPinToggle])
   .directive('permalink', ['$document', '$window', 'translationService', '$timeout', 'configService', 'shortenUrlService', Permalink])
   .directive('confirmClick', ['$window', ConfirmClick])
   .directive('topLinks', TopLinks)
   .directive('vpnBanner', ['$timeout','$compile',VpnBanner])
   .directive('translatableTextWithLink', TranslatableTextWithLink)
   .directive('translatableTextWithDropdown', ['menuManagerService', TranslatableTextWithDropdown])
   .directive('dynamicLink', DynamicLink)
   .directive('ellipsis', ['$timeout', Ellipsis])
   .directive('knowTextWidth', ['$timeout', KnowTextWidth])
   .directive('savedItemsDialog', SavedItemsDialog)
   .directive('detailPage', DetailPage)
   .directive('homeView', HomeView)
   .directive('searchView', SearchView)
   .directive('searchResultsTabs', SearchResultsTabs)
   .directive('links', ['configService', Links])
   .directive('customLinksHeader', CustomLinksHeader)
   .directive('customLinksMenu', CustomLinksMenu)
   .directive('navTabs', NavTabs)
   .directive('languageSwitcher', LanguageSwitcher)
   .directive('menuBar', MenuBar)
   .directive('facetDatepickers', [ 'translationService', FacetDatepickers])
   .directive('linkedContributorList', ['configService', 'translationService', LinkedContributorList])
   .directive('linkedSubjectList', LinkedSubjectList)
   .directive('journalTitleSearchLink', JournalTitleSearchLink)
   .directive('layout', Layout)
   .directive('header', Header)
   .directive('backToTop', ['$window', 'translationService', BackToTop])
   .directive('idleTimer', ['$document', 'configService', 'flowService', IdleTimer])
   .directive('citation', Citation)
   .directive('citationSidebar', CitationSidebar)
   .directive('draggable', ['$document', '$window', Draggable])
   .directive('scrollToTop', ['$window', '$timeout', ScrollToTop])
   .directive('scrollToTopOnClick', [ScrollToTopOnClick])
   .directive('ngEnter', ['$timeout', NgEnter])
   .directive('keyedClick', [KeyedClick])
   .directive('toggleImage', ['$timeout', ToggleImage])
   .directive('summonFormAction', SummonFormAction)
   .directive('datePresetLinks', ['translationService', DatePresetLinks])
   .directive('facetDatePresetLinks', ['translationService', 'viewStateService', FacetDatePresetLinks])
   .directive('libraryNotes', LibraryNotes)
   .directive('previewEnv', PreviewEnv)
   .directive("appRecaptchaEnterprise", ['recaptchaService', '$timeout', Recaptcha])
   .directive('pagination', Pagination)
   .directive('modalHeader', ['translationService', 'dialogService', ModalHeader])
   .directive('quickLookContent', QuickLookContent)
   .directive('quickLookDetails', QuickLookDetails)
   .directive('secondaryResourceTypesWarning', SecondaryResourceTypesWarning)
   .directive('quickLookNavigation', QuickLookNavigation)
   .directive('recordActionsGroup', RecordActionsGroup)
   .directive('titleToggle', ['translationService', TitleToggle])
   .directive('menu', ['$timeout', Menu])
   .directive('visible', Visible)
   .directive('arrowNavMenu', ['localizationService', ArrowNavMenu])
   .directive('keyboardNav', KeyboardNav)
   .directive('arrowFocusTarget', ['$timeout', ArrowFocusTarget])
   .directive('hideUntilLoaded', ['$timeout', HideUntilLoaded])
